import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const HISTORY_API_URL = 'servicios-history/';

export const fetchServiceHistory = async () => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(HISTORY_API_URL);
        return response.data;
    });
};